<template>
  <div class="unionbank-box">
    <img width="180" :src="require('../../assets/uniBank.png')" alt="">
    <p class="amount">amount</p>
    <span class="nums">{{ 20000 | fenToYanAndFormat }}</span><span class="php">PHP</span>
    <div class="confirm">
      <Button class="btn">Confirm</Button>
    </div>
  </div>
</template>

<script>
import { Button } from 'mand-mobile'
import { fenToYanAndFormat } from '@/utils/format-amount'
// 支付结果 查询
export default {
  name: 'UnionBankConfirm',

  components: {
    Button
  },
  filters: {
    fenToYanAndFormat
  }
}
</script>

<style scoped lang="scss">
.unionbank-box {
  padding: 24px;
  padding-top: 200px;
  text-align: center;
}

.amount {
  font-size: 36px;
  line-height: 56px;
  margin-bottom: 24px;
  margin-top: 60px;
}

.nums {
  padding-right: 16px;
  font-size: 72px;
  color: #303133;
}

.php {
  font-size: 36px;
}

.confirm {
  margin-top: 600px;

  .btn {
    width: 100%;
    background: #ffea33;
    border-radius: 16px;
  }
}
</style>
